import React from 'react';

import InputErrors from './InputErrors';

function SoftAlert({ errors }) {
  return (
    <div className="soft-alert">
      <InputErrors errors={errors} />
    </div>
  );
}

export default SoftAlert;



// WEBPACK FOOTER //
// ./src/components/common/SoftAlert.js